import CategoryPage from "./CategoryPage";

export default function PGCoLiving() {
  return (
    <CategoryPage
      categoryName="PG/Co-living"
      categorySlug="pg-co-living"
      categoryIcon="🏨"
      categoryDescription="Paying guest and co-living accommodations in Rohtak"
    />
  );
}
